import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { Order } from "@/types"
import { fetchAllOrders, fetchOrdersSummary, fetchPendingOrders } from "./ordersThunks"

interface OrdersState {
  orders: Order[]
  pendingOrders: Order[]
  summary: any
  loading: boolean
  loaded: boolean
  pendingLoaded: boolean
  error: string | null
}

const initialState: OrdersState = {
  orders: [],
  pendingOrders: [],
  summary: null,
  loading: false,
  loaded: false,
  pendingLoaded: false,
  error: null,
}

const ordersSlice = createSlice({
  name: "orders",
  initialState,
  reducers: {
    mergePendingOrders: (state) => {
      const existingIds = new Set(state.orders.map(o => o.orderId))
      state.pendingOrders.forEach(po => {
        if (!existingIds.has(po.orderId)) {
          state.orders.push(po)
        }
      })
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllOrders.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchAllOrders.fulfilled, (state, action: PayloadAction<Order[]>) => {
        state.loading = false
        state.loaded = true
        state.orders = action.payload
      })
      .addCase(fetchAllOrders.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload || "Failed to fetch orders"
      })
      .addCase(fetchOrdersSummary.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchOrdersSummary.fulfilled, (state, action) => {
        state.loading = false
        state.summary = action.payload
      })
      .addCase(fetchOrdersSummary.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload || "Failed to fetch orders summary"
      })
      .addCase(fetchPendingOrders.pending, (state) => {
        state.error = null
      })
      .addCase(fetchPendingOrders.fulfilled, (state, action: PayloadAction<Order[]>) => {
        state.pendingLoaded = true
        state.pendingOrders = action.payload
      })
      .addCase(fetchPendingOrders.rejected, (state, action) => {
        state.error = action.payload || "Failed to fetch pending orders"
      })
  },
})

export const { mergePendingOrders } = ordersSlice.actions
export default ordersSlice.reducer
